import { Option } from '@lib/interfaces/form';
import { Ordering } from '../enums';

export default function getSortedOptions(opts: Option[], direction: Ordering) {
  switch (direction) {
    case Ordering.AtoZ:
      return [...opts].sort((a, b) =>
        String(a.label ?? '').localeCompare(String(b.label ?? ''), undefined, {
          sensitivity: 'base',
        }),
      );
    case Ordering.ZtoA:
      return [...opts].sort((a, b) =>
        String(b.label ?? '').localeCompare(String(a.label ?? ''), undefined, {
          sensitivity: 'base',
        }),
      );
    case Ordering.Default:
    default:
      return [...opts].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  }
}
